import { apiClient } from "helpers/api_helper";
import { CustomerLedgerEntry } from "modules/transactions/new-sales-entry/services";
import { useCallback, useState } from "react";

export const getAllStoreLedgerData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/StoreLedger/GetStoreLedger`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
export const getAllStoreReciept = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/StoreLedger/GetInerStoreMayaveInvoice?ledgerId=${data}`);
        console.log(response)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const useStoreLedger = () => {
    const [ledgerEntries, setLedgerEntries] = useState<CustomerLedgerEntry[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [totalBalance, setTotalBalance] = useState({ credit: 0, debit: 0, balance: 0 });

    const getCustomerLedger = useCallback(async (customerId: number): Promise<CustomerLedgerEntry[]> => {
        if (!customerId) {
            setError('Customer ID is required');
            return [];
        }

        setLoading(true);
        setError(null);

        try {
            const response = await apiClient.get(`/api/v1/Ledger/GetCustomerLedgerDetailsByCustomerId?customerId=${customerId}`);
            if (response.data) {
                const ledgerData = response.data || [];

                let runningBalance = 0;
                let totalCredit = 0;
                let totalDebit = 0;

                const processedEntries = ledgerData.map((entry: any) => {
                    if (entry.transactionType === 'Credit') {
                        runningBalance += entry.transactionAmount;
                        totalCredit += entry.transactionAmount;
                    } else {
                        runningBalance -= entry.transactionAmount;
                        totalDebit += entry.transactionAmount;
                    }

                    return {
                        ...entry,
                        runningBalance: runningBalance
                    };
                });

                setLedgerEntries(processedEntries);
                setTotalBalance({
                    credit: totalCredit,
                    debit: totalDebit,
                    balance: runningBalance
                });

                return processedEntries;
            } else {
                const errorMsg = response.data?.message || "Failed to fetch customer ledger";
                setError(errorMsg);
                return [];
            }
        } catch (err: any) {
            let errorMessage = "Failed to fetch customer ledger";

            if (err.response?.status === 404) {
                errorMessage = "Customer ledger not found";
            } else if (err.response?.status === 400) {
                errorMessage = err.response?.data?.message || "Invalid customer ID";
            } else if (err.response?.data?.message) {
                errorMessage = err.response.data.message;
            }

            setError(errorMessage);
            setLedgerEntries([]);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    const clearLedgerData = useCallback(() => {
        setLedgerEntries([]);
        setError(null);
        setTotalBalance({ credit: 0, debit: 0, balance: 0 });
    }, []);

    return {
        ledgerEntries,
        loading,
        error,
        totalBalance,
        getCustomerLedger,
        clearLedgerData
    };
};